<md-content-box>
    <md-icon [icon]="iconName()"></md-icon>
    <div class="content">
        <ng-content></ng-content>
    </div>
</md-content-box>